import styled from 'styled-components';

const CloseButton = styled.button`
  position: absolute;
  right: 13px;
  top: 13px;
  width: 32px;
  height: 32px;
  opacity: 0.8;
  background-color: rgb(255, 255, 255);
  border-radius: 30px;
  cursor: pointer;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 1;
  }
  &:before {
    position: absolute;
    left: 15px;
    top: 7px;
    content: ' ';
    height: 60%;
    width: 2px;
    background-color: #333;
    transform: rotate(45deg);
  }
  &:after {
    position: absolute;
    left: 15px;
    top: 7px;
    content: ' ';
    height: 60%;
    width: 2px;
    background-color: #333;
    transform: rotate(-45deg);
  }
`;

export default CloseButton;
